{
  "TemplatingEngineUrl": "https://pon-universe-templateengine.azurewebsites.net",
  "AppInsightsConnectionString": "InstrumentationKey=5a943fb0-c026-4924-bf5e-fb3a60f442f4;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=2a7d0819-14bf-468f-a6a8-ed359fa11ae6",
  "EnableApplicationInsights": true,
  "DapUrl": "https://dap-pon.mendixcloud.com/link/Contract/",
  "FeatureSwitches": {
    "EnableLeaseCompanies": true
  },
  "EnableInactivityTimer": true
}
